/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_TermsInputs */

const en_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const zh_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务条款`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Landing_Footer_TermsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_footer_terms = /** @type {((inputs?: Landing_Footer_TermsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_TermsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_footer_terms(inputs)
	return zh_landing_footer_terms(inputs)
});
export { landing_footer_terms as "landing.footer.terms" }